import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CommonModule } from '@angular/common';
import { PwaUpdateNotificationService } from '../../../core/services/pwa-update-notification.service';

@Component({
  selector: 'isc-pwa-update-notification',
  imports: [CommonModule],
  templateUrl: './pwa-update-notification.html',
  styleUrl: './pwa-update-notification.scss',
})


export class PwaUpdateNotification {
  private readonly swUpdate = inject(PwaUpdateNotificationService);
  private readonly destroyRef = inject(DestroyRef);

  readonly showUpdateMessage = signal(false);

  constructor() {
    this.swUpdate.initWatcher();

    this.swUpdate.showUpdateMessage
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((res: boolean) => {
        this.showUpdateMessage.set(res);
      });
  }

  confirmUpdate(): void {
    this.showUpdateMessage.set(false);

    // Reload page to activate latest SW version
    window.location.reload();
  }

  cancelUpdate(): void {
    this.showUpdateMessage.set(false);
    this.swUpdate.cancelUpdate();
  }
}
